import type { UtmParams } from '@t/session.types';

const UTM_KEY_MAP: Record<string, keyof UtmParams> = {
  utm_source: 'utmSource',
  utm_medium: 'utmMedium',
  utm_campaign: 'utmCampaign',
  utm_term: 'utmTerm',
  utm_content: 'utmContent',
};

/**
 * Parses UTM parameters from a URL search string.
 * Accepts the search string as a parameter for testability (Dependency Inversion).
 */
export const getUtmParams = (search: string): UtmParams | undefined => {
  const params = new URLSearchParams(search);
  const utm: UtmParams = {};
  let hasAny = false;

  for (const [urlKey, camelKey] of Object.entries(UTM_KEY_MAP)) {
    const value = params.get(urlKey);
    if (value) {
      utm[camelKey] = value;
      hasAny = true;
    }
  }

  return hasAny ? utm : undefined;
};
